__turbopack_context__.v({
  "gridContainer": "AboutPro-module__597ufa__gridContainer",
  "imageWrapper": "AboutPro-module__597ufa__imageWrapper",
  "scrollWrapper": "AboutPro-module__597ufa__scrollWrapper",
});
